'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _pageLocal = require('./page.local.css');

var _pageLocal2 = _interopRequireDefault(_pageLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Page = function Page(_ref) {
  var children = _ref.children;
  return _react2.default.createElement('main', {
    className: _pageLocal2.default.page
  }, children);
};

Page.propTypes = {
  /**
   * Content of the page
   */
  children: _propTypes.PropTypes.node.isRequired
};
exports.default = Page;